module.exports = __webpack_public_path__ + "static/img/70f2486.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/lhsx/4.png
// module id = 643
// module chunks = 2